export const TECHNOLOGY_TYPE_LABELS: Record<string, string> = {
    SAAS_PRODUCT: 'Exposure Intelligence',
    ASSET: 'External Scan',
    OTHER: 'Manually Added',
}
